import axios from 'axios'

export default {
  getDictionaryList: function () {
    return axios.get('/api/nsi/dictionaries', {});
  },
  getDictionary: function (name) {
    return axios.get(`/api/nsi/dictionaries/${name}`, {});
  },
  getItems: function(request) {
    return axios.get(`/api/nsi/items`, { params: request })
  },
  getItem: function(request) {
    return axios.get(`/api/nsi/items/${request.name}/${request.id}`, {})
  },
  create: function (name, data) {
    return axios.post(`/api/nsi/items/${name}`, data);
  },
  update: function(name, data) {
    return axios.put(`/api/nsi/items/${name}/${data.id}`, data);
  },
  delete: function (name, id) {
    return axios.delete(`/api/nsi/items/${name}/${id}`);
  },
  importExcel: function(name, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post( `/api/nsi/dictionaries/${name}/import`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
  },
  getNsi: function(dictName, request) {
    return axios.get('/api/nsi/' + dictName, { params: request })
  },
  getNsiItems: function(dictName, request) {
    return axios.get('/api/nsi/items?dictName=' + dictName, { params: request })
  },
  importRMIS: function(id) {
    return axios.get('/api/import/updatermisdictionary?id=' + id)
  },
  getEducationalPrograms: function (educationLevelId) {
    return axios.get(`/api/nsi/educationalprogram?educationLevelId=${educationLevelId}`, {});
  },
  getClassKinds: function (educationLevelId) {
    return axios.get(`/api/nsi/classkind?educationLevelId=${educationLevelId}`, {});
  },
  getClassLevels: function (educationLevelId) {
    return axios.get(`/api/nsi/classlevel?educationLevelId=${educationLevelId}`, {});
  },
  getRecommedations: function(recom, educationalProgramId) {
    return axios.get(`/api/nsi/recom${recom}?educationalProgramId=${educationalProgramId}`, {});
  },
  getOrganizationTypes: function(kindActivityId) {
    return axios.get(`/api/nsi/organizationtype?kindActivityId=${kindActivityId}`, {});
  },
  getServiceTypes: function(kindActivityId) {
    let url = `/api/nsi/ServiceType`;
    if (kindActivityId) url += `?kindActivityId=${kindActivityId}`;
    return axios.get(url, {});
  }
}
